@if (control.errors) {
	@if (control.errors['required']) {
		<span>{{ 'validation.required' | translate }}</span>
	} @else if (control.errors['minlength']) {
		<span>{{ 'validation.minLength' | translate: { requiredLength: control.errors['minlength']['requiredLength'] } }}</span>
	} @else if (control.errors['maxLength']) {
		<span>{{ 'validation.maxLength' | translate: { requiredLength: control.errors['maxlength']['requiredLength'] } }}</span>
	} @else if (control.errors['email']) {
		<span>{{ 'validation.email' | translate }}</span>
	} @else if (control.errors['min']) {
		<span>{{ 'validation.min' | translate: { min: control.errors['min']['min'] } }}</span>
	} @else if (control.errors['max']) {
		<span>{{ 'validation.max' | translate: { max: control.errors['max']['max'] } }}</span>
	} @else if (control.errors['pattern']) {
		<span>{{ 'validation.pattern' | translate }}</span>
	} @else if (control.errors['invalidDate']) {
		<span>{{ 'validation.invalidDate' | translate }}</span>
	} @else if (control.errors['underAge']) {
		<span>{{ 'validation.underAge' | translate }}</span>
	} @else if (control.errors['differentOdd']) {
		<span>{{ 'validation.differentOdd' | translate }}</span>
	} @else if (control.errors['validOdd']) {
		<span>{{ 'validation.invalidOdd' | translate }}</span>
	} @else if (control.errors['insufficientBalance']) {
		<span>{{ 'Insufficient Balance' | translate }}</span>
	} @else if (control.errors['betAllow']) {
		<span>{{ 'validation.betAllow' | translate }}</span>
	} @else if (control.errors['missingUpperCase']) {
		<span>{{ 'validation.missingUpperCase' | translate: { amount: control.errors['missingUpperCase']['amount'] } }}</span>
	} @else if (control.errors['missingLowerCase']) {
		<span>{{ 'validation.missingLowerCase' | translate: { amount: control.errors['missingLowerCase']['amount'] } }}</span>
	} @else if (control.errors['missingNumbers']) {
		<span>{{ 'validation.missingNumbers' | translate: { amount: control.errors['missingNumbers']['amount'] } }}</span>
	} @else if (control.errors['missingSpecialCharacter']) {
		<span>{{ 'validation.missingSpecialCharacter' | translate: { amount: control.errors['missingSpecialCharacter']['amount'] } }}</span>
	} @else if (control.errors['passwordMismatch']) {
		<span>{{ 'validation.passwordMismatch' | translate: { amount: control.errors['passwordMismatch']['amount'] } }}</span>
	}
}
